import request from '@/libs/http/index'

export interface LearnNoticePayload {
  id?: number
  content: string
  deptId: number | string
  startTime: string
  endTime: string
  advanceDay?: number
  isSyncPatient: boolean
}

// 获取学习公示
export const getLearnNotice = () => {
  return request.get({ url: '/clinic/learn-notice/get' })
}

// 创建学习公示
export const createLearnNotice = (data: LearnNoticePayload) => {
  return request.post({ url: '/clinic/learn-notice/create', data })
}

// 更新学习公示
export const updateLearnNotice = (data: LearnNoticePayload) => {
  return request.put({ url: '/clinic/learn-notice/update', data })
}

// 获取学习公示分页
export const getLearnNoticePage = params => {
  return request.get({ url: '/clinic/learn-notice/page', params })
}
